<template>
    <span
        v-if="direction==='right'"
        class="SysFontM tag_item"
        :style="{'background': setColor(item.color,0.5),'borderColor':item.color}"
    >
        {{item.name}}
        <i
            :style="{'borderLeftColor': $utils.hexToRgb(item.color, 0.5),'--color':item.color}"
        ></i>
    </span>
    <span
        v-else
        class="SysFontM tag_item tag_left_item"
        :style="{ 'borderColor': setColor(item.color,0.3), 'background': $utils.hexToRgb(item.color, 0.1), 'color': item.color}"
    >
        {{item.name}}
        <i
            :style="{'--color': item.color,'borderRightColor': $utils.hexToRgb(item.color, 0.1)}"
        ></i>
    </span>
</template>
<script>
/**
 * ComponentName: 带箭头的标签 不规则样式样式
 * Created Date:2022/5/13
 * Author: shishuo·zhang
 * Modify：haogang·du 2022/5/17
 * 组件说明：
 * eg:
 *    <cl-tag-other :item="item"></cl-tag-other>
 */
export default {
    name: 'cl-tag-other',
    data () {
        return {

        };
    },
    props: {
        item: {
            type: Object,
            default: () => { }
        },
        direction: { // 标签箭头的方向:left/right
            type: String,
            default: 'right'
        }
    },
    computed: {
        setColor () {
            return (color, type) => {
                let res = this.$utils.hexToRgb(color, type)
                return res
            }
        }
    },
    methods: {

    },
}
</script>
<style lang='scss' scoped>
.tag_item {
    font-size: 14px;
    position: relative;
    display: inline-block;
    color: #fff;
    height: 24px;
    box-sizing: border-box;
    text-align: center;
    padding: 0 8px;
    line-height: 22px;
    border-width: 1px;
    border-right-width: 0;
    border-style: solid;
    margin-right: 14px;
    &.tag_left_item {
        border-right-width: 1px;
        border-left-width: 0px;
        i {
            left: -7px;
            border-left-width: 0px;
            border-right-width: 7px;
            border-right-style: solid;
            border-bottom: 11px solid transparent;
            color: transparent;
            &::before {
                content: '';
                right: -5px;
                top: -17px;
                transform: rotate(212deg);
            }
            &::after {
                content: '';

                right: -19px;
                bottom: -9px;
                transform: rotate(329deg);
            }
        }
    }
    i {
        position: absolute;
        right: -7px;
        top: 0;
        width: 0;
        height: 0;
        border-top: 11px solid transparent;
        border-left-width: 7px;
        border-left-style: solid;
        border-bottom: 11px solid transparent;
        &::before {
            height: 14px;
            width: 15px;
            border-left: var(--color) solid 1px;
            position: absolute;
            right: -11px;
            top: -17px;
            border-radius: 1px;
            transform: rotate(328deg);
            opacity: .7;
            content: '';
        }
        &::after {
            content: '';
            height: 15px;
            width: 16px;
            border-left: var(--color) solid 1px;
            position: absolute;
            right: 2px;
            bottom: -9px;
            border-radius: 1px;
            transform: rotate(211deg);
            opacity: .7;
        }
    }
}
</style>
